import { useState } from "react";
import { X, Plus } from "lucide-react";
import { Section } from "@/components/ui-brand";

export const PanelHeader = ({ title, subtitle, right }) => (
  <div className="bg-[var(--brand-primary)] text-white">
    <Section className="py-8 flex flex-wrap items-center justify-between gap-4">
      <div>
        <h1 className="font-heading font-extrabold text-2xl sm:text-3xl">{title}</h1>
        {subtitle && <p className="text-white/70 text-sm mt-1">{subtitle}</p>}
      </div>
      {right}
    </Section>
  </div>
);

export const Tabs = ({ tabs, active, onChange }) => (
  <div className="border-b border-slate-100 bg-white sticky top-16 z-30">
    <Section className="flex gap-1 overflow-x-auto">
      {tabs.map((t) => (
        <button key={t.key} onClick={() => onChange(t.key)} data-testid={`tab-${t.key}`}
          className={`px-4 py-3.5 text-sm font-heading font-bold whitespace-nowrap border-b-2 transition-colors ${active === t.key ? "border-[var(--brand-accent)] text-[var(--brand-accent)]" : "border-transparent text-[var(--brand-text-muted)] hover:text-[var(--brand-primary)]"}`}>
          {t.label}{t.badge ? <span className="ml-1.5 text-xs px-1.5 py-0.5 rounded-full text-white" style={{ background: "var(--brand-accent)" }}>{t.badge}</span> : null}
        </button>
      ))}
    </Section>
  </div>
);

export const TagInput = ({ tags, onChange, suggestions = [], placeholder = "Agregar…", testid }) => {
  const [val, setVal] = useState("");
  const add = (t) => { const v = (t || val).trim(); if (v && !tags.includes(v)) onChange([...tags, v]); setVal(""); };
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {tags.map((t) => (
          <span key={t} className="chip" data-testid={`${testid}-tag-${t}`}>{t}
            <button onClick={() => onChange(tags.filter((x) => x !== t))} className="ml-1" data-testid={`${testid}-remove-${t}`}><X size={12} /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input list={`${testid}-list`} value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
          placeholder={placeholder} data-testid={`${testid}-input`}
          className="flex-1 rounded-full border-2 border-[var(--brand-border)] px-4 py-2 text-sm outline-none focus:border-[var(--brand-accent)]" />
        <datalist id={`${testid}-list`}>{suggestions.map((s) => <option key={s} value={s} />)}</datalist>
        <button onClick={() => add()} className="btn-accent px-4" data-testid={`${testid}-add`}><Plus size={16} /></button>
      </div>
    </div>
  );
};

export const Field = ({ label, textarea, error, ...props }) => {
  const cls = `mt-1 w-full rounded-xl border-2 px-4 py-2.5 text-sm outline-none focus:border-[var(--brand-accent)] ${error ? "border-red-400" : "border-[var(--brand-border)]"}`;
  const testid = props["data-testid"];
  return (
    <label className="block">
      <span className="text-xs font-semibold text-[var(--brand-primary)]">{label}</span>
      {textarea ? <textarea {...props} aria-invalid={!!error} className={`${cls} min-h-[100px]`} />
        : <input {...props} aria-invalid={!!error} className={cls} />}
      {error && <span role="alert" className="block text-xs text-red-600 mt-1" data-testid={testid ? `${testid}-error` : undefined}>{error}</span>}
    </label>
  );
};

export const Card = ({ children, className = "", ...rest }) => <div className={`card-brand p-6 ${className}`} {...rest}>{children}</div>;
